import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import VueGtag from "vue-gtag";
createApp(App).use(VueGtag, {
  config: { id: "G-XPK2TFFSXW" }
}).mount("#root");